import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import { icons } from "../../assets/icons";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import CustomAccordion from "../../components/CustomAccordion";
import { FaCheck, FaChevronDown, FaChevronUp } from "react-icons/fa";
import Checkbox from "react-custom-checkbox";
import { apiUrls } from "../../utils/api/apiUrls";
import useApi from "../../hooks/useApi";
import { toast } from "react-toastify";

const CreateRoles = () => {
  const { data = [], apiCall } = useApi();
  const { apiCall: createRole } = useApi();
  const { apiCall: updateRole } = useApi();
  const paramsData = useLocation();
  const [authorityIds, setAuthorityIds] = useState(paramsData?.state?.roleAuthorities ? Object.keys(paramsData?.state?.roleAuthorities).map(i => Number(i)) : []);
  const [roleName, setRoleName] = useState(paramsData?.state?.name || "");
  const [description, setDescription] = useState(paramsData?.state?.description || "");
  const isUpdateRoleActive = paramsData?.state?.id ? true : false;

  useEffect(() => {
    apiCall({
      url: apiUrls.sso.getAuthorities,
      method: "get",
    });
  }, []);

  const navigate = useNavigate();
  const onClickBack = () => {
    navigate(-1);
  };
  const [activeMainAuthority, setActiveMainAuthority] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const onClickSave = () => {
    if (!roleName) {
      toast.error("Role name is requried");
      return;
    }
    if (!description) {
      toast.error("Description is requried");
      return;
    }
    if (!authorityIds.length) {
      toast.error("Please select atleast one authority below");
      return;
    }

    createRole({
      url: apiUrls.sso.createRole,
      method: "post",
      dataToSend: {
        name: roleName,
        description,
        authorities: authorityIds,
      },
      onSuccess: () => {
        toast.success("Role created successfully");
        navigate(-1);
      },
    });
  };

  const onClickUpdate = () => {
    if (!roleName) {
      toast.error("Role name is requried");
      return;
    }
    if (!description) {
      toast.error("Description is requried");
      return;
    }
    if (!authorityIds.length) {
      toast.error("Please select atleast one authority below");
      return;
    }

    updateRole({
      url: apiUrls.sso.updateRole,
      method: "put",
      dataToSend: {
        id: paramsData?.state?.id || "",
        name: roleName,
        description,
        authorities: authorityIds,
      },
      onSuccess: () => {
        toast.success("Role Update successfully");
        navigate(-1);
      },
    });
  };
  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Roles > Create Role"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          return (
            <div className="flex items-center gap-x-6">
              <CustomButton
                title="Back"
                wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
                textClassName="text-[var(--blackColor)] pl-2"
                onClick={onClickBack}
                icon={icons.backIcon}
              />
              <CustomButton
                title={isUpdateRoleActive ? "Update" : "Save"}
                wrapperClassName="!px-5"
                textClassName="pl-2"
                onClick={isUpdateRoleActive ? onClickUpdate : onClickSave}
              />
            </div>
          );
        }}
      />

      <div className="px-6 py-8 bg-[#fff] mt-10 rounded-[1rem]">
        <div className="font-size-large font-family-medium mb-3">Add Role</div>
        {/* <div className="font-size-small mb-5 text-[var(--darkGray2)]">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry.
        </div> */}
        <div className="flex gap-x-8">
          <InputWithIcon
            title="Role Name"
            wrapperClassName="flex-1"
            containerClassName="!min-h-[4rem] !bg-transparent border-[1px] border-[var(--borderGray1)]"
            placeholder="Enter the role name here"
            onChange={(e) => {
              setRoleName(e);
            }}
            value={roleName}
          />
          <InputWithIcon
            title="Description"
            wrapperClassName="flex-1"
            containerClassName="!min-h-[4rem] !bg-transparent border-[1px] border-[var(--borderGray1)]"
            placeholder="Enter the description here"
            onChange={(e) => {
              setDescription(e);
            }}
            value={description}
          />
        </div>
      </div>
      <div className="px-6 py-8 bg-[#fff] mt-6 rounded-[1rem]">
        {data?.map((service, serviceIndex) => {
          const accordionItems = service?.resources?.map((resource, rIndex) => {
            return {
              renderLeft: () => {
                return (
                  <div
                    className="flex items-center gap-x-5"
                    key={"left" + rIndex}
                  >
                    <Checkbox
                      size={22}
                      borderRadius={2}
                      borderWidth={1}
                      borderColor="#707070"
                      icon={<FaCheck size={18} color="#000" />}
                      onChange={() => {
                        if (
                          resource?.authorities?.every((authority) =>
                            authorityIds.includes(authority?.id)
                          )
                        ) {
                          setAuthorityIds(
                            authorityIds.filter(
                              (id) =>
                                !resource?.authorities
                                  .map((authority) => authority.id)
                                  .includes(id)
                            )
                          );
                        } else {
                          setAuthorityIds([
                            ...authorityIds,
                            ...resource?.authorities?.map(
                              (authority) => authority?.id
                            ),
                          ]);
                        }
                      }}
                      checked={resource?.authorities?.every((authority) =>
                        authorityIds.includes(authority?.id)
                      )}
                    />
                    <div className="font-family-medium font-size-medium">
                      {resource?.resource}
                    </div>
                  </div>
                );
              },
              Component: () => {
                return (
                  <div
                    className="bg-[#F8F8F8] rounded-[1rem] flex justify-center py-8"
                    key={"component" + rIndex}
                  >
                    <div className="flex w-[90%] flex-wrap gap-y-8">
                      {resource?.authorities?.map(
                        (authority, authorityIndex) => {
                          return (
                            <div
                              className="flex items-center gap-x-5 min-w-[30%]"
                              key={"authority" + authorityIndex}
                            >
                              <Checkbox
                                size={22}
                                borderRadius={2}
                                borderWidth={1}
                                borderColor="#707070"
                                icon={<FaCheck size={18} color="#000" />}
                                checked={authorityIds.includes(authority?.id)}
                                onChange={() => {
                                  if (!authorityIds.includes(authority?.id)) {
                                    setAuthorityIds([
                                      ...authorityIds,
                                      authority?.id,
                                    ]);
                                  } else {
                                    let newAuthorityIds = [...authorityIds];
                                    newAuthorityIds.splice(
                                      authorityIds.findIndex(
                                        (id) => id === authority?.id
                                      ),
                                      1
                                    );
                                    setAuthorityIds(newAuthorityIds);
                                  }
                                }}
                              />
                              <div className="font-family-medium font-size-medium">
                                {authority?.authorityName}
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                );
              },
            };
          });
          return (
            <React.Fragment key={"service" + serviceIndex}>
              <div
                className="flex justify-between cursor-pointer mt-4 "
                onClick={() => {
                  if (activeMainAuthority === 0 || activeMainAuthority) {
                    setActiveMainAuthority(null);
                    return;
                  }
                  setActiveMainAuthority(serviceIndex);
                }}
              >
                <div>
                  <div className="font-size-large font-family-medium mb-2">
                    {service.service}
                  </div>
                  {/* <div className="font-size-small mb-2 text-[var(--darkGray2)]">
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry.
                  </div> */}
                </div>
                <FaChevronDown size={25} color="black" />
              </div>
              {activeMainAuthority === serviceIndex && (
                <>
                  <div className="h-[1px] bg-[#707070] mt-6" />
                  <CustomAccordion
                    items={accordionItems}
                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}
                  />
                </>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="flex items-center justify-between mt-10">
        <CustomButton
          title="Back"
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
          textClassName="text-[var(--blackColor)] pl-2"
          onClick={onClickBack}
          icon={icons.backIcon}
        />
        <CustomButton
          title={isUpdateRoleActive ? "Update" : "Save"}
          wrapperClassName="!px-5"
          textClassName="pl-2"
          onClick={isUpdateRoleActive ? onClickUpdate : onClickSave}
        />
      </div>
    </div>
  );
};

export default CreateRoles;
